export default __webpack_public_path__ + "static/media/p04 p03.834bb85f.jpg";